import React from "react";
import { ToastContainer } from "react-toastify";
import excel from "../../images/excel (2).svg";
import Placeholder from "../../images/Place Holder 3 1.webp";
import Placeholder1 from "../../images/Place Holder.webp";
import Placeholder2 from "../../images/Place Holder_1.webp";
import loader from "../../images/LandingPageImage/Isancharr.svg";
import useAdminCampaigns from "../../services/Admin/useAdminCampaigns";
import { RefreshCcw } from "lucide-react";

const StatusBadge = ({ status, reason }) => {
  const statusClassMap = {
    delivered: "bg-green-50 text-green-700 border-green-200",
    failed: "bg-red-50 text-red-700 border-red-200",
    read: "bg-blue-50 text-blue-700 border-blue-200",
    interested: "bg-yellow-50 text-yellow-700 border-yellow-200",
    accepted: "bg-sky-50 text-sky-700 border-sky-200",
    submitted: "bg-rose-50 text-rose-700 border-rose-200",
    reply: "bg-lime-50 text-lime-700 border-lime-200",
    Completed: "bg-green-50 text-green-700 border-green-200",
    Stopped: "bg-red-50 text-red-700 border-red-200",
    Running: "bg-lime-50 text-lime-700 border-lime-200",
    Failed: "bg-red-50 text-red-700 border-red-200",
  };

  return (
    <span
      title={reason || status?.toUpperCase()}
      className={`inline-block min-w-[120px] cursor-pointer rounded-full border px-3 py-1 text-center text-[12px] font-medium capitalize ${
        statusClassMap[status] || "border-gray-200 bg-gray-50 text-gray-700"
      }`}
    >
      {status}
    </span>
  );
};

const StatusTemplateBadge = ({ templateID, templates }) => {
  const template = templates.find((item) => item.name === templateID);

  const extractHeaderAndBody = (templateData) => {
    let headerText = "";
    let bodyText = "";

    if (
      templateData &&
      templateData.components &&
      Array.isArray(templateData.components)
    ) {
      templateData.components.forEach((component) => {
        if (component.type === "HEADER" && component.text) {
          headerText = component.text;
        }

        if (component.type === "BODY" && component.text) {
          bodyText = component.text;
        }
      });
    }

    return { headerText, bodyText };
  };

  const message = extractHeaderAndBody(template);

  return (
    <span
      title={`${message.headerText} ${message.bodyText}`}
      className="cursor-pointer text-blue-600 hover:underline"
    >
      {templateID}
    </span>
  );
};

const Pagination = ({
  currentPage,
  totalPages,
  onNextPage,
  onPrevPage,
  onPageClick,
}) => {
  if (!totalPages || totalPages <= 1) return null;

  const pages = Array.from({ length: Math.min(totalPages, 5) }, (_, index) => {
    const page = index + 1;
    return page;
  });

  return (
    <div className="flex items-center justify-center gap-2 py-4">
      <button
        type="button"
        onClick={onPrevPage}
        disabled={currentPage === 1}
        className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-700 disabled:cursor-not-allowed disabled:opacity-50"
      >
        Prev
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onPageClick(page)}
          className={`rounded-md border px-3 py-2 text-sm font-semibold ${
            currentPage === page
              ? "border-blue-600 bg-blue-600 text-white"
              : "border-gray-300 bg-white text-gray-700"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={onNextPage}
        disabled={currentPage === totalPages}
        className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-700 disabled:cursor-not-allowed disabled:opacity-50"
      >
        Next
      </button>
    </div>
  );
};

const AdminCampaigns = ({ Admin }) => {
  const {
    loading,
    filteredItems,

    logs,
    modalLoading,
    isLogsModalOpen,
    closeLogsModal,

    status,
    campName,

    currentPage,
    totalPages,
    itemsPerPage,
    handlePageClick,
    handleNextPage,
    handlePrevPage,

    filterText,
    setFilterText,

    templates,
    selectedTemplate,
    isPreviewLoading,
    showPreviewModal,
    closePreviewModal,
    animate,

    getLogs,
    handlePreview,
    refresh,
    replaceVariablesBody,
    downloadExcel,
  } = useAdminCampaigns({ Admin });

  return (
    <div className="min-h-screen bg-[#dfedff36]">
      <ToastContainer />

      {/* Preview Modal */}
      {showPreviewModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 px-4">
          <div className="w-full max-w-[520px] rounded-xl bg-white shadow-xl">
            <div className="flex items-center justify-between border-b border-gray-200 px-5 py-4">
              <h3 className="text-lg font-bold text-gray-800">
                Message Preview
              </h3>

              <button
                type="button"
                onClick={closePreviewModal}
                className="rounded-md px-2 py-1 text-xl text-gray-500 hover:bg-gray-100"
              >
                ×
              </button>
            </div>

            <div className="p-5">
              {isPreviewLoading ? (
                <div className="flex flex-col items-center justify-center py-8">
                  <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-200 border-t-blue-600" />
                  <p className="mt-3 text-sm font-medium text-gray-500">
                    Generating preview...
                  </p>
                </div>
              ) : selectedTemplate ? (
                <div className="rounded-lg bg-gray-100 p-6">
                  <div
                    className={`rounded-xl border border-gray-200 bg-white p-4 shadow-sm transition-all duration-300 ${
                      animate ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0"
                    }`}
                  >
                    <div className="flex justify-center">
                      {selectedTemplate.components?.find(
                        (c) => c.format === "IMAGE"
                      ) && (
                        <img src={Placeholder} alt="" className="w-56" />
                      )}

                      {selectedTemplate.components?.find(
                        (c) => c.format === "VIDEO"
                      ) && (
                        <img src={Placeholder1} alt="" className="w-56" />
                      )}

                      {selectedTemplate.components?.find(
                        (c) => c.format === "DOCUMENT"
                      ) && (
                        <img src={Placeholder2} alt="" className="w-56" />
                      )}
                    </div>

                    <div className="mt-3 font-bold text-gray-900">
                      {selectedTemplate.components?.find(
                        (c) => c.type === "HEADER"
                      )?.text || ""}
                    </div>

                    <div className="py-2 text-sm leading-6 text-gray-700">
                      {replaceVariablesBody(
                        selectedTemplate.components?.find(
                          (c) => c.type === "BODY"
                        )?.text || ""
                      )}
                    </div>

                    <div className="text-xs text-gray-500">
                      {selectedTemplate.components?.find(
                        (c) => c.type === "FOOTER"
                      )?.text || ""}
                    </div>

                    <div className="mt-2 text-right text-xs text-gray-400">
                      05:27 PM
                    </div>
                  </div>

                  {selectedTemplate.components
                    ?.find((c) => c.type === "BUTTONS")
                    ?.buttons?.map((button, index) => (
                      <div
                        key={index}
                        className={`mt-2 rounded-lg border border-gray-200 bg-white p-2 text-center text-sm font-semibold text-green-600 transition-all duration-300 ${
                          animate ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0"
                        }`}
                      >
                        {button.text}
                      </div>
                    ))}
                </div>
              ) : (
                <p className="py-6 text-center text-sm font-semibold text-gray-500">
                  No template found.
                </p>
              )}
            </div>

            <div className="flex justify-end border-t border-gray-200 px-5 py-4">
              <button
                type="button"
                onClick={closePreviewModal}
                className="rounded-md bg-gray-600 px-4 py-2 text-sm font-semibold text-white hover:bg-gray-700"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="h-screen bg-white p-4 font-sans">
        <div className="px-4">
          <div className="mb-4 rounded-lg bg-gray-50 p-4">
            <div className="flex items-center justify-between gap-4">
              <h2 className="text-2xl font-bold text-gray-800">
                WhatsApp Message Logs
              </h2>

              <button
                type="button"
                title="Refresh"
                onClick={refresh}
                className="flex h-10 w-10 items-center justify-center rounded-lg border border-gray-200 bg-white transition hover:bg-gray-100"
              >
                <RefreshCcw className="h-5 w-5 text-gray-600" />
              </button>
            </div>

            <hr className="my-4" />

            <div className="flex justify-start">
              <input
                type="text"
                placeholder="Search..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                className="mb-3 h-[42px] w-full max-w-[520px] rounded-md border border-gray-300 bg-white px-4 text-sm font-medium text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
              />
            </div>
          </div>

          {loading ? (
            <div className="m-5 flex justify-center p-5">
              <div className="flex flex-col items-center justify-center">
                <div className="h-9 w-9 animate-spin rounded-full border-4 border-blue-200 border-t-blue-600" />

                <div className="p-3">
                  <img src={loader} alt="" height={40} />
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="max-h-[calc(100vh-250px)] overflow-auto rounded-lg border border-gray-200">
                <table className="min-w-[1900px] w-full border-collapse bg-white text-sm">
                  <thead>
                    <tr className="bg-[#007bff] text-center text-white">
                      {[
                        "S.No.",
                        "ID",
                        "User Name",
                        "Campaign Name",
                        "Start Time",
                        "End Time",
                        "Template",
                        "Category",
                        "Sent",
                        "Delivered",
                        "Accepted",
                        "Read",
                        "Failed",
                        "Responded",
                        "Preview",
                        "Audience",
                        "Status",
                      ].map((head) => (
                        <th
                          key={head}
                          className="whitespace-nowrap border border-blue-400 px-3 py-3 font-bold"
                        >
                          {head}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {filteredItems.map((item, index) => (
                      <tr
                        key={item.id || index}
                        className="border-b border-gray-200 text-center hover:bg-gray-50"
                      >
                        <td className="whitespace-nowrap border px-3 py-3">
                          {(currentPage - 1) * itemsPerPage + index + 1}
                        </td>

                        <td className="whitespace-nowrap border px-3 py-3">
                          {item.id}
                        </td>

                        <td className="whitespace-nowrap border px-3 py-3">
                          {item.user_name}
                        </td>

                        <td className="whitespace-nowrap border px-3 py-3 font-semibold">
                          {item.campaign_name?.toUpperCase()}
                        </td>

                        <td className="whitespace-nowrap border px-3 py-3">
                          {item.campaign_start}
                        </td>

                        <td className="whitespace-nowrap border px-3 py-3">
                          {item.campaign_end}
                        </td>

                        <td className="whitespace-nowrap border px-3 py-3">
                          <StatusTemplateBadge
                            templateID={item.template_id}
                            templates={templates}
                          />
                        </td>

                        <td className="whitespace-nowrap border px-3 py-3 font-bold">
                          {item.template_category}
                        </td>

                        {[
                          "sent",
                          "delivered",
                          "accepted",
                          "read",
                          "failed",
                          "responded",
                        ].map((logStatus) => (
                          <td
                            key={logStatus}
                            onClick={() =>
                              getLogs(
                                logStatus,
                                item.id,
                                item.campaign_name,
                                item.userid
                              )
                            }
                            className="cursor-pointer whitespace-nowrap border px-3 py-3 font-bold text-blue-600 hover:underline"
                          >
                            {item[logStatus] || 0}
                          </td>
                        ))}

                        <td className="whitespace-nowrap border px-3 py-3">
                          <button
                            type="button"
                            onClick={() =>
                              handlePreview(
                                item.template_id,
                                item.userid,
                                item.phone_no_id
                              )
                            }
                            className="rounded-md bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-600 hover:bg-blue-100"
                          >
                            Preview
                          </button>
                        </td>

                        <td className="whitespace-nowrap border px-3 py-3">
                          <a
                            href={item.excel_url}
                            download
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex justify-center"
                          >
                            <img src={excel} alt="" className="h-8" />
                          </a>
                        </td>

                        <td className="whitespace-nowrap border px-3 py-3">
                          <StatusBadge status={item.status} reason={item.error} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onNextPage={handleNextPage}
                onPrevPage={handlePrevPage}
                onPageClick={handlePageClick}
              />
            </>
          )}
        </div>
      </div>

      {/* Logs Modal */}
      {isLogsModalOpen && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 px-4">
          <div className="flex max-h-[85vh] w-[75vw] flex-col rounded-lg bg-white p-4 shadow-xl">
            <h2 className="mb-3 text-center text-2xl font-bold text-gray-800">
              {campName} - {status?.toUpperCase()}
            </h2>

            {logs.length > 0 && (
              <button
                type="button"
                onClick={downloadExcel}
                className="mb-3 ml-auto rounded-md bg-green-600 px-4 py-2 text-sm font-semibold text-white hover:bg-green-700"
              >
                Download Excel Report
              </button>
            )}

            <div className="overflow-auto">
              <table className="w-full min-w-[1400px] border-collapse text-sm">
                <thead>
                  <tr>
                    {[
                      "ID",
                      "Contact",
                      "Business Acc Id",
                      "Phone No Id",
                      "Status",
                      "Date",
                      "Product",
                      "Category",
                      "Contact Name",
                      "Message Category",
                      "Error code",
                      "Error Description",
                    ].map((head) => (
                      <th
                        key={head}
                        className="border border-gray-300 bg-blue-600 px-3 py-2 text-white"
                      >
                        {head}
                      </th>
                    ))}
                  </tr>
                </thead>

                {modalLoading ? (
                  <tbody>
                    <tr>
                      <td colSpan={12} className="py-8 text-center">
                        Loading logs...
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {logs.map((item) => (
                      <tr key={item.id} className="text-center hover:bg-gray-50">
                        <td className="border px-3 py-2">{item.id}</td>
                        <td className="border px-3 py-2">{item.contact}</td>
                        <td className="border px-3 py-2">
                          {item.business_acc_id}
                        </td>
                        <td className="border px-3 py-2">{item.phone_no_id}</td>
                        <td className="border px-3 py-2">{item.status}</td>
                        <td className="border px-3 py-2">{item.indate}</td>
                        <td className="border px-3 py-2">{item.product}</td>
                        <td className="border px-3 py-2">{item.category}</td>
                        <td className="border px-3 py-2">
                          {item.contact_name || "N/A"}
                        </td>
                        <td className="border px-3 py-2">
                          {item.message_category}
                        </td>
                        <td className="border px-3 py-2">
                          {item.error_code || "N/A"}
                        </td>
                        <td className="border px-3 py-2">
                          {item.error || "N/A"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>

            <button
              type="button"
              onClick={closeLogsModal}
              className="mt-3 ml-auto rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-700"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminCampaigns;